/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
$(document).ready(function(){

//   $(".video-wrapper__image-wrapper").click(function(){
//     $("iframe#VIDEO").play();
//   });
 
  $(window).scroll(function() {
     if ($(this).scrollTop() > 10)
     {
      //$('.header').addClass("sticky_header");
      $('body').addClass("body_sticky");
     }
     else
     {
      //$('.header').removeClass("sticky_header");
      $('body').removeClass("body_sticky");
     }
  });
  function checkPosition(){
    if (window.matchMedia('(max-width: 999px)').matches) {
      jQuery('.text-with-icons-slick_slider').not('.slick-initialized').slick({
        slidesToShow: 2,
        adaptiveHeight:true,
        slidesToScroll: 1,
        infinite: false,
        arrows: false,
        dots: true,
        responsive: [
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 2,
              adaptiveHeight:true,
              slidesToScroll: 1,
              infinite: false,
              arrows: false,
              dots: true
            }
          }
        ]
      });
    } else if(window.matchMedia('(min-width: 1000px)').matches) {
      if(jQuery('.text-with-icons-slick_slider').hasClass('slick-initialized')){
        jQuery('.text-with-icons-slick_slider').slick('unslick');
      }
    }
    

  }
  jQuery(window).on("resize", checkPosition);
  jQuery(window).on("load", checkPosition);
  jQuery(window).on("orientationchange", checkPosition);
  
  function blogSlider(){
    if (window.matchMedia('(max-width: 999px)').matches) {
      jQuery('.blog-slider .block-list').not('.slick-initialized').slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        centerMode: true,
        arrows:false,
        centerPadding:'20%',
        autoplay: true,
        autoplaySpeed: 5000,
        responsive: [
          {
            breakpoint: 999,
            settings: {
              centerPadding: '15%',
            }
          }
        ]
      });
    }
  }

  blogSlider();
  $(window).on('resize',function() {
    blogSlider();
  });
  function featuredCollectionSlider(){
    if (window.matchMedia('(min-width: 999px)').matches) {
      console.log('innn 111');
      if($('[data-section-type="featured-collection"] .product-list').hasClass('flickity-enabled')){
        console.log('has flick');
        $('[data-section-type="featured-collection"] .product-list').flickity('destroy');
        $('[data-section-type="featured-collection"] .product-list').flickity({
          watchCSS: true,
          pageDots: false,
          prevNextButtons: true,
          contain: true,
          groupCells: true,
          cellAlign: 'left',
          draggable: true
        });
      }
    }
    else{
      if($('[data-section-type="featured-collection"] .product-list').hasClass('flickity-enabled')){
        $('[data-section-type="featured-collection"] .product-list').flickity('destroy');
      }
    }
  }
  featuredCollectionSlider();
});
$(window).on('resize',function() {
  function featuredCollectionSlider(){
    if (window.matchMedia('(min-width: 999px)').matches) {
      console.log('innn 111');
      if($('[data-section-type="featured-collection"] .product-list').hasClass('flickity-enabled')){
        console.log('has flick');
        $('[data-section-type="featured-collection"] .product-list').flickity('destroy');
        $('[data-section-type="featured-collection"] .product-list').flickity({
          watchCSS: true,
          pageDots: false,
          prevNextButtons: true,
          contain: true,
          groupCells: true,
          cellAlign: 'left',
          draggable: true
        });
      }
      else if($('.product-recommendations .product-list').hasClass('flickity-enabled')){
      	$('.product-recommendations .product-list').flickity('destroy');
        $('.product-recommendations .product-list').flickity({
          watchCSS: true,
          pageDots: false,
          prevNextButtons: true,
          contain: true,
          groupCells: true,
          cellAlign: 'left',
          draggable: true
        });
      }
      else if($('#shopify-section-static-recently-viewed-products .product-list').hasClass('flickity-enabled')){
      	$('#shopify-section-static-recently-viewed-products .product-list').flickity('destroy');
        $('#shopify-section-static-recently-viewed-products .product-list').flickity({
          watchCSS: true,
          pageDots: false,
          prevNextButtons: true,
          contain: true,
          groupCells: true,
          cellAlign: 'left',
          draggable: true
        });
      }
      else{
        $('[data-section-type="featured-collection"] .product-list').flickity({
          watchCSS: true,
          pageDots: false,
          prevNextButtons: true,
          contain: true,
          groupCells: true,
          cellAlign: 'left',
          draggable: true
        });
        $('.product-recommendations .product-list').flickity({
          watchCSS: true,
          pageDots: false,
          prevNextButtons: true,
          contain: true,
          groupCells: true,
          cellAlign: 'left',
          draggable: true
        });
        $('#shopify-section-static-recently-viewed-products .product-list').flickity({
          watchCSS: true,
          pageDots: false,
          prevNextButtons: true,
          contain: true,
          groupCells: true,
          cellAlign: 'left',
          draggable: true
        });
      }
    }
    else{
      if($('[data-section-type="featured-collection"] .product-list').hasClass('flickity-enabled')){
        $('[data-section-type="featured-collection"] .product-list').flickity('destroy');
      }
      if($('.product-recommendations .product-list').hasClass('flickity-enabled')){
        $('.product-recommendations .product-list').flickity('destroy');
      }
      if($('#shopify-section-static-recently-viewed-products .product-list').hasClass('flickity-enabled')){
        $('#shopify-section-static-recently-viewed-products .product-list').flickity('destroy');
      }
    }
  }
  featuredCollectionSlider();
});
$(window).on('load',function() {
  function featuredCollectionSlider(){
    if (window.matchMedia('(min-width: 999px)').matches) {
      console.log('innn 111');
      if($('[data-section-type="featured-collection"] .product-list').hasClass('flickity-enabled')){
        console.log('has flick');
        $('[data-section-type="featured-collection"] .product-list').flickity('destroy');
        $('[data-section-type="featured-collection"] .product-list').flickity({
          watchCSS: true,
          pageDots: false,
          prevNextButtons: true,
          contain: true,
          groupCells: true,
          cellAlign: 'left',
          draggable: true
        });
      }
      else if($('.product-recommendations .product-list').hasClass('flickity-enabled')){
      	$('.product-recommendations .product-list').flickity('destroy');
        $('.product-recommendations .product-list').flickity({
          watchCSS: true,
          pageDots: false,
          prevNextButtons: true,
          contain: true,
          groupCells: true,
          cellAlign: 'left',
          draggable: true
        });
      }
      else if($('#shopify-section-static-recently-viewed-products .product-list').hasClass('flickity-enabled')){
      	$('#shopify-section-static-recently-viewed-products .product-list').flickity('destroy');
        $('#shopify-section-static-recently-viewed-products .product-list').flickity({
          watchCSS: true,
          pageDots: false,
          prevNextButtons: true,
          contain: true,
          groupCells: true,
          cellAlign: 'left',
          draggable: true
        });
      }
      else{
        $('[data-section-type="featured-collection"] .product-list').flickity({
          watchCSS: true,
          pageDots: false,
          prevNextButtons: true,
          contain: true,
          groupCells: true,
          cellAlign: 'left',
          draggable: true
        });
        $('.product-recommendations .product-list').flickity({
          watchCSS: true,
          pageDots: false,
          prevNextButtons: true,
          contain: true,
          groupCells: true,
          cellAlign: 'left',
          draggable: true
        });
        $('#shopify-section-static-recently-viewed-products .product-list').flickity({
          watchCSS: true,
          pageDots: false,
          prevNextButtons: true,
          contain: true,
          groupCells: true,
          cellAlign: 'left',
          draggable: true
        });
      }
    }
    else{
      if($('[data-section-type="featured-collection"] .product-list').hasClass('flickity-enabled')){
        $('[data-section-type="featured-collection"] .product-list').flickity('destroy');
      }
      if($('.product-recommendations .product-list').hasClass('flickity-enabled')){
        $('.product-recommendations .product-list').flickity('destroy');
      }
      if($('#shopify-section-static-recently-viewed-products .product-list').hasClass('flickity-enabled')){
        $('#shopify-section-static-recently-viewed-products .product-list').flickity('destroy');
      }
    }
  }
  featuredCollectionSlider();
});

// https://hitlights.com/apps/wpdapp
// $( "<div class='container text-center'><p>Inspiring The Use of High Quality LED Strip Lights Globally</p></div>" ).insertAfter( $( "#wpd-create-customer" ) );
$('#section-1602007118077 .quick-links').flickity({
  watchCSS: true,
  pageDots: false,
  prevNextButtons: false,
  contain: true,
  groupCells: true,
  cellAlign: 'left',
  draggable: true
});

var cur_url = window.location.href;
if(cur_url == 'https://hitlights.com/apps/wpdapp'){
   $('.wpdapp-email').removeClass('hide');
}
// $('.nav-bar').find('li').click(function(){
//        //removing the previous selected menu state
//        $('.nav-bar').find('a.active').removeClass('active');

//         //is this element from the second level menu?
//         if($(this).closest('ul').hasClass('nav-dropdown')){
//              $(this).parents('li').addClass('active');

//         //this is a parent element
//         }else{
//              $(this).addClass('active');
//         }
//     });
$( "li a.active" ).parent().closest('.nav-bar__item').css( "color", "#710cab" );
